export default "__VITE_PUBLIC_ASSET__a307b9a9__"